export default __webpack_public_path__ + "static/media/startup-guide_img.d32262e2.jpg";